import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { AppState } from 'src/redux/types';
import APIS from 'src/utils/apiUrl';
import { getAuthToken } from 'src/utils/auth/getAuthToken';
import { logActions } from '../../log/actions';
import { logInfoActions } from '../actions';
import { JobLog } from '../../../models/jobLog';
import { sendEventGuestTriedExpiredShare, sendEventGuestViewedJobReport } from '../../../utils/api/auditEventsApi';
import { AuthUserInfo } from '../../auth/types';
import { SHARE_EXPIRED_HTTP_STATUS } from '../reducer';

/** A thunk action that fetches information about the given log from the sentinel system. */
export const tryFetchLogInfo =
  (logId: string, user: AuthUserInfo | undefined): ThunkAction<void, AppState, undefined, AnyAction> =>
  async dispatch => {
    let logInfoResult: AxiosResponse | undefined = undefined;
    try {
      dispatch(logActions.tryFetchLogInfoStart());
      const token = await getAuthToken();
      if (!token) throw new Error('Tried to fetch log info without an auth token!');
      const accessToken = token.access.token;
      const requestConfig: AxiosRequestConfig = {
        headers: { Authorization: `Bearer ${accessToken}` },
        validateStatus: () => true,
      };
      logInfoResult = await axios.get(`${APIS.SENTINEL_API}/api/logs/getForGuest?_id=${logId}`, requestConfig);
      if (logInfoResult?.status === 200) {
        const logInfo: JobLog = logInfoResult.data;
        dispatch(logInfoActions.tryFetchLogInfoSuccess(logInfo));
        sendEventGuestViewedJobReport(logInfo, user).then(); // Empty then to silence warning about unused Promise.
      } else {
        dispatch(logInfoActions.tryFetchLogInfoFailure(logInfoResult?.status));
        if (logInfoResult?.status === SHARE_EXPIRED_HTTP_STATUS) {
          sendEventGuestTriedExpiredShare(logId, user).then(); // Empty then to silence warning about unused Promise.
        }
      }
    } catch (e) {
      console.error('Failed to fetch log info', logInfoResult?.status);
      dispatch(logInfoActions.tryFetchLogInfoFailure(500));
    }
  };
